import React, { useEffect, useState } from 'react';
import { Box, Button, Link as MuiLink, Paper, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const COOKIE_CONSENT_KEY = 'yuzhen_cookie_consent';
const COOKIE_CONSENT_EVENT = 'yuzhen-cookie-consent-change';

const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const storedChoice = window.localStorage.getItem(COOKIE_CONSENT_KEY);
    setVisible(!storedChoice);
  }, []);

  const saveChoice = (value: 'accepted' | 'necessary') => {
    window.localStorage.setItem(COOKIE_CONSENT_KEY, value);
    window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_EVENT, { detail: value }));
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        left: { xs: 12, md: 24 },
        right: { xs: 12, md: 24 },
        bottom: { xs: 12, md: 24 },
        zIndex: 1400,
      }}
    >
      <Paper
        elevation={12}
        sx={{
          p: { xs: 2, md: 2.5 },
          borderRadius: 4,
          border: '1px solid rgba(15, 23, 42, 0.08)',
          boxShadow: '0 20px 50px rgba(15, 23, 42, 0.18)',
        }}
      >
        <Stack spacing={1.5}>
          <Typography variant="h6" sx={{ fontWeight: 800 }}>
            Cookie и похожие технологии
          </Typography>

          <Typography color="text.secondary">
            Мы используем cookie, localStorage и похожие технологии для работы сайта, сохранения корзины, анализа
            посещаемости и рекламных инструментов. Подробнее об этом можно прочитать в{' '}
            <MuiLink component={Link} to="/privacy" underline="hover">
              Политике конфиденциальности
            </MuiLink>
            .
          </Typography>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25} alignItems={{ sm: 'center' }}>
            <Button variant="contained" onClick={() => saveChoice('accepted')}>
              Принять
            </Button>
            <Button
              variant="text"
              color="inherit"
              onClick={() => saveChoice('necessary')}
              sx={{
                color: 'text.secondary',
                alignSelf: { xs: 'flex-start', sm: 'center' },
                px: { xs: 0, sm: 1 },
                minWidth: 'auto',
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: 'text.primary',
                },
              }}
            >
              Только необходимые
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
};

export default CookieBanner;
